import { useTranslation } from 'react-i18next'

const PHONE_NUMBER = '50432649600'

const messages: Record<string, string> = {
  es: 'Hola, me gustaría información sobre Hotel Nueva Valladolid',
  en: 'Hello, I would like information about Hotel Nueva Valladolid',
}

export function WhatsAppButton() {
  const { i18n } = useTranslation()
  const locale = i18n.language.startsWith('en') ? 'en' : 'es'
  const message = messages[locale] || messages.es
  const whatsappUrl = `https://wa.me/${PHONE_NUMBER}?text=${encodeURIComponent(message)}`

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
      className="fixed bottom-20 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-lg transition-transform duration-300 hover:scale-110 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-[#25D366] focus:ring-offset-2 md:bottom-6"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        className="h-8 w-8 fill-white"
      >
        <path d="M16.004 0C7.164 0 .002 7.158.002 15.995c0 2.82.737 5.573 2.14 7.998L.01 32l8.186-2.09a15.94 15.94 0 0 0 7.808 2.03C24.844 31.94 32 24.782 32 15.944 32 7.158 24.844 0 16.004 0zm0 29.332a13.33 13.33 0 0 1-7.16-2.083l-.512-.306-5.318 1.36 1.42-5.148-.336-.533A13.27 13.27 0 0 1 2.61 15.995C2.61 8.6 8.606 2.607 16.004 2.607S29.397 8.6 29.397 15.995c0 7.394-5.997 13.337-13.393 13.337zm7.327-9.99c-.4-.2-2.37-1.17-2.738-1.303-.368-.134-.636-.2-.904.2-.268.4-1.04 1.303-1.274 1.57-.235.268-.47.302-.87.1-.4-.2-1.69-.623-3.22-1.986-1.19-1.06-1.994-2.37-2.228-2.77-.234-.4-.025-.616.176-.815.18-.18.4-.468.602-.702.2-.234.268-.4.4-.668.134-.268.068-.502-.032-.702-.1-.2-.904-2.18-1.238-2.986-.326-.783-.658-.677-.904-.69l-.77-.012c-.268 0-.702.1-1.07.502-.368.4-1.404 1.37-1.404 3.342 0 1.97 1.438 3.876 1.638 4.144.2.268 2.83 4.32 6.858 6.058.96.414 1.708.66 2.292.846.963.306 1.84.263 2.532.16.773-.116 2.37-.97 2.704-1.906.334-.936.334-1.738.234-1.906-.1-.168-.368-.268-.77-.468z" />
      </svg>
    </a>
  )
}
